import React from 'react';

const StudentProfileModal = ({ isOpen, onClose, student }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
      <div className="bg-white p-6 rounded-lg shadow-lg w-96 max-w-2xl overflow-y-auto max-h-[90vh]">
        <div className="flex justify-between mb-6">
          <h2 className="text-2xl font-semibold text-gray-800">Student Profile</h2>
          <button onClick={onClose} className="text-red-500 hover:text-red-700 transition-colors">
            Close
          </button>
        </div>

        <div className="mb-6">
          <img
            src={student.profile?.image || 'defaultProfilePic.jpg'}
            alt="Profile"
            className="w-32 h-32 rounded-full mx-auto mb-4 border-4 border-gray-300"
          />
          <div className="text-center">
            <h3 className="text-xl font-medium text-gray-800">{student.profile?.name}</h3>
            <p className="text-sm text-gray-500">{student.email}</p>
            <p className="text-sm text-gray-500">{student.profile?.phone}</p>
          </div>
        </div>

        <div className="text-sm text-gray-600 space-y-3 mb-6">
          <div>
            <strong className="text-gray-700">Gender:</strong> {student.profile?.gender}
          </div>
          <div>
            <strong className="text-gray-700">Date of Birth:</strong> {new Date(student.profile?.dob).toLocaleDateString()}
          </div>
          <div>
            <strong className="text-gray-700">Parents' Contact:</strong> {student.profile?.parentsContactNumber}
          </div>
          <div>
            <strong className="text-gray-700">Address:</strong> {student.profile?.address}
          </div>
          <div>
            <strong className="text-gray-700">Total Payments:</strong> {student.profile?.totalPayments}
          </div>
          <div>
            <strong className="text-gray-700">Coins:</strong> {student.profile?.coins}
          </div>
          <div>
            <strong className="text-gray-700">Trials Left:</strong> {student.profile?.trialsLeft}
          </div>
        </div>

        <div className="mt-6">
          <h4 className="font-semibold text-lg mb-4 text-gray-800">Academies & Batch Details</h4>
          <div className="space-y-4">
            {student.academyId?.length > 0 ? (
              student.academyId.map((academy, index) => (
                <div key={index}>
                  <strong className="text-gray-700">Academy:</strong> {academy.name}
                </div>
              ))
            ) : (
              <div>No academies enrolled.</div>
            )}

            {student.batchDetails?.length > 0 ? (
              student.batchDetails.map((batch, index) => (
                <div key={index} className="space-y-2">
                  <div>
                    <strong className="text-gray-700">Batch ID:</strong> {batch.batchId || 'N/A'}
                  </div>
                  <div>
                    <strong className="text-gray-700">Student Academy ID:</strong> {batch.studentacademyid}
                  </div>
                  <div>
                    <strong className="text-gray-700">Admission Date:</strong> {new Date(batch.admissionDate).toLocaleDateString()}
                  </div>
                  <div>
                    <strong className="text-gray-700">Is Active:</strong> {batch.isActive ? 'Yes' : 'No'}
                  </div>
                </div>
              ))
            ) : (
              <div>No batch details available.</div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default StudentProfileModal;
